module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-alerts-page-wrapper"
  }, [_c('AllAlertsPage')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02d8dd74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/AllAlertsPageWrapper.vue
// module id = 714
// module chunks = 2